<style lang="stylus" scoped></style>

<template>
  <el-table ref="singleTable" :data="allData" stripe max-height="400" style="width: 100%">
    <el-table-column type="index" width="50" label="  ">
      <template slot-scope="scope">
        <span>{{scope.$index+index+1}}</span>
      </template>
    </el-table-column>
    <el-table-column property="name" label="加油站名称" align="center"></el-table-column>
    <el-table-column property="kind" label="品牌" align="center"></el-table-column>
    <el-table-column property="longLat" label="经纬度" align="center"></el-table-column>
    <el-table-column property="provname" label="省份" align="center"></el-table-column>
    <el-table-column property="cityname" label="城市" align="center"></el-table-column>
    <el-table-column property="adminname" label="区县" align="center"></el-table-column>
    <!-- <el-table-column property="address" label="地理位置" align="center"></el-table-column> -->
    <el-table-column property="count" label="停靠次数" align="center"></el-table-column>
  </el-table>
</template>
<script>
export default {
  props: {
    allData: {
      type: Array,
      default: () => {
        return []
      }
    },
    index: {
      type: Number
    }
  }
}
</script>